module.exports = ".cabezera {\n  background: #253a5b;\n  color: white; }\n\n.cabezera-card {\n  border-color: #253a5b; }\n\n.mat-select-arrow {\n  color: white; }\n\n.select-cabezera {\n  color: white; }\n\n.mynewcolor {\n  color: white; }\n\n.btn-nuevo > span {\n  margin-top: -17px;\n  position: absolute;\n  width: 100%;\n  left: 0px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Contabilidad/polizas/polizas-consultar/polizas-consultar.component.scss
// module id = ./src/app/Contabilidad/polizas/polizas-consultar/polizas-consultar.component.scss
// module chunks = main